// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__R7oJS","footer":"ChangeClinic_footer__1R7bQ"};